import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { StatsReport } from '../../../interfaces/report';
import { SapiService } from '../../../services/sapi.service';
import { OverlayService } from '../../../services/overlay.service';


@Component({
	selector: 'report-details-schedule',
	templateUrl: './report-details-schedule.component.html',
	styleUrls: ['./report-details-schedule.component.scss']
})

export class ReportDetailsScheduleComponent implements OnInit, OnDestroy {
	@Input() form: NgForm;
	@Input() report: StatsReport;

	subscriptions: Subscription;
	generateReportOptions: any = [];
	weekdays: any = [];

	constructor(
		private translate: TranslateService,
		private overlayService: OverlayService,
		private sapiService: SapiService
	) {
		this.subscriptions = new Subscription();
		this.generateReportOptions = [
			{ label: this.translate.instant('MANUALLY'), value: 'manually', default: true },
			{ label: this.translate.instant('DAILY'), value: 'daily' },
			{ label: this.translate.instant('WEEKLY_ON'), value: 'weekly' },
			{ label: this.translate.instant('MONTHLY', { x: 30 }), value: 'monthly' },
		];

		this.weekdays = [
			{ label: this.translate.instant('MONDAY'), value: 'monday' },
			{ label: this.translate.instant('TUESDAY'), value: 'tuesday' },
			{ label: this.translate.instant('WEDNESDAY'), value: 'wednesday' },
			{ label: this.translate.instant('THURSDAY'), value: 'thursday' },
			{ label: this.translate.instant('FRIDAY'), value: 'friday' },
			{ label: this.translate.instant('SATURDAY'), value: 'saturday' },
			{ label: this.translate.instant('SUNDAY'), value: 'sunday' },
		];

	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	addEmail() {
		if (!this.report.recipients) {
			this.report.recipients = [];
			this.report.recipients.push('');
		}

		const lastEmail = this.report.recipients[this.report.recipients.length - 1];
		if (lastEmail && lastEmail !== '') {
			this.report.recipients.push('');
			this.form.form.markAsDirty();
		}
	}

	removeEmail(index: any) {
		this.report.recipients.splice(index, 1);
		this.form.form.markAsDirty();
	}

	generateReportNow() {
		this.sapiService.postUrl('/report/' + this.report.id + '/job').subscribe((response: any) => {
			const msg = this.translate.instant('SUCCESS_QUEUING_ENTITY2', { entity: this.translate.instant('REPORT').toLowerCase() });
			this.overlayService.createToast(msg, 'save');
		},
		(err) => {
			const msg = this.translate.instant('ERROR_QUEING_ENTITY2',
				{ entity: this.translate.instant('REPORT'), errorMessage: err.statusText, errorCode: err.status });
			this.overlayService.createToast(msg, 'warning');
		});
	}

	trackByIndex(index: number, item: any) {
		return index;
	}
}
